import { Modal } from 'ant-design-vue';

export default {
  Modal
}